// Its fine to have a static map id for publication because we will only
// ever render 1 map for a publication.
// We will also never render 2 publications at the same time,
// so there will be no conflicts with multiple maps having the same id.

export const PUBLICATION_MAP_ID = "publication-map";
